const HOUSES = [
  { x: 60, w: 70, h: 55, roof: 30 },
  { x: 175, w: 58, h: 44, roof: 26 },
  { x: 285, w: 82, h: 62, roof: 34 },
  { x: 425, w: 55, h: 42, roof: 24 },
  { x: 545, w: 76, h: 58, roof: 30 },
  { x: 690, w: 60, h: 48, roof: 26 },
  { x: 810, w: 72, h: 55, roof: 30 },
];

const PINES = [
  { x: 20, s: 1 },
  { x: 145, s: 0.8 },
  { x: 390, s: 1.1 },
  { x: 660, s: 0.9 },
  { x: 770, s: 0.75 },
  { x: 1140, s: 1 },
];

const Window = ({ x, y, delay }) => (
  <rect
    x={x}
    y={y}
    width="7"
    height="9"
    rx="1"
    fill="#F3C96B"
    className="animate-[twinkle_3.4s_ease-in-out_infinite]"
    style={{ animationDelay: `${delay}s` }}
  />
);

const House = ({ x, w, h, roof }) => (
  <g>
    <rect x={x} y={240 - h} width={w} height={h} fill="#0B1D15" />
    <polygon
      points={`${x - 5},${240 - h} ${x + w / 2},${240 - h - roof} ${x + w + 5},${240 - h}`}
      fill="#12261C"
    />
    <polygon
      points={`${x - 5},${240 - h} ${x + w / 2},${240 - h - roof} ${x + w + 5},${240 - h}`}
      fill="none"
      stroke="#E8EEF4"
      strokeOpacity="0.45"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <Window x={x + w * 0.22} y={240 - h + 14} delay={(x % 7) * 0.4} />
    <Window x={x + w * 0.6} y={240 - h + 20} delay={(x % 5) * 0.6} />
  </g>
);

const Pine = ({ x, s }) => (
  <g transform={`translate(${x}, 0) scale(${s})`}>
    <polygon points="0,240 14,205 28,240" fill="#0E2A1E" />
    <polygon points="3,218 14,188 25,218" fill="#123526" />
    <polygon points="3,218 14,188 25,218" fill="none" stroke="#E8EEF4" strokeOpacity="0.35" strokeWidth="1.5" />
  </g>
);

export const VillageSilhouette = ({ className = "" }) => (
  <svg viewBox="0 0 1200 260" preserveAspectRatio="xMidYMax meet" className={className} aria-hidden>
    {/* mountain ridges */}
    <path
      d="M0,150 L140,55 L260,130 L400,40 L540,120 L680,60 L820,125 L960,50 L1100,115 L1200,70 L1200,260 L0,260 Z"
      fill="#0A1B14"
    />
    <path
      d="M0,195 L180,110 L340,178 L520,95 L700,172 L880,108 L1060,170 L1200,120 L1200,260 L0,260 Z"
      fill="#0D241A"
    />
    {/* snow caps */}
    {[
      [140, 55],
      [400, 40],
      [680, 60],
      [960, 50],
    ].map(([px, py], i) => (
      <polygon
        key={i}
        points={`${px - 22},${py + 28} ${px},${py} ${px + 22},${py + 28} ${px + 8},${py + 20} ${px},${py + 26} ${px - 8},${py + 20}`}
        fill="#E8EEF4"
        opacity="0.28"
      />
    ))}

    {/* church */}
    <g>
      <rect x="985" y="150" width="36" height="90" fill="#0B1D15" />
      <polygon points="980,150 1003,104 1026,150" fill="#12261C" />
      <polygon points="980,150 1003,104 1026,150" fill="none" stroke="#E8EEF4" strokeOpacity="0.45" strokeWidth="2.5" />
      <rect x="998" y="118" width="10" height="14" rx="4" fill="#F3C96B" className="animate-[twinkle_4s_ease-in-out_infinite]" />
      <Window x={994} y={200} delay={1.2} />
      <Window x={1006} y={200} delay={2.1} />
    </g>

    {HOUSES.map((house, i) => (
      <House key={i} {...house} />
    ))}
    {PINES.map((pine, i) => (
      <Pine key={i} {...pine} />
    ))}

    {/* snowy ground */}
    <path d="M0,240 C300,228 500,246 760,236 C1000,228 1120,242 1200,236 L1200,260 L0,260 Z" fill="#DCE7F0" opacity="0.2" />
  </svg>
);
